import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    if (attempts >= 7) return;
    if (status.payment_status === "paid") return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        setAttempts((a) => a + 1);
      } catch {
        setAttempts((a) => a + 1);
      }
    }, 2000);
    return () => clearTimeout(t);
  }, [sessionId, attempts, status.payment_status]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="payment-success-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-8 flex items-center justify-center">
          <div className="max-w-md w-full bg-white border border-slate-200 rounded-md p-10 text-center">
            {status.payment_status === "paid" ? (
              <>
                <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-600" />
                <h1 className="font-display font-extrabold text-3xl text-slate-900 mt-3">Paiement confirmé</h1>
                <p className="text-sm text-slate-600 mt-2">Votre dépanneur est notifié. Vous pouvez suivre la mission dans votre tableau de bord.</p>
                <Button onClick={() => navigate("/dashboard")} className="mt-6 bg-orange-600 hover:bg-orange-700">Retour au tableau de bord</Button>
              </>
            ) : attempts >= 7 ? (
              <>
                <XCircle className="h-14 w-14 mx-auto text-red-500" />
                <h1 className="font-display font-extrabold text-2xl text-slate-900 mt-3">Statut en attente</h1>
                <p className="text-sm text-slate-600 mt-2">La confirmation prend plus de temps que prévu. Consultez vos notifications.</p>
                <Link to="/notifications"><Button variant="outline" className="mt-6">Voir notifications</Button></Link>
              </>
            ) : (
              <>
                <Loader2 className="h-10 w-10 mx-auto animate-spin text-orange-600" />
                <h1 className="font-display font-bold text-xl text-slate-900 mt-3">Vérification du paiement…</h1>
                <p className="text-sm text-slate-600 mt-1">Patientez quelques secondes.</p>
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
